import request from 'superagent'
import R from 'ramda'

const sendRequest = method => (url, payload, callback) => request[method](url)
  .withCredentials()
  .set('Content-Type', 'application/json')
  .accept('json')
  .send(payload)
  .end((err, res) => {
    if (err || R.has('error', R.prop('body', res))) {
      const errMsg = R.path(['body', 'error'], res) || R.path(['response', 'body', 'error'], err) || err
      return callback(errMsg)
    }
    return callback()
  })

export const sendPost = sendRequest('post')
export const sendPatch = sendRequest('patch')
export const sendDelete = sendRequest('delete')



// WEBPACK FOOTER //
// ./webAdmin/views/xero/sendRequest.js